import { AppLoading } from '@/components/AppLoading'
import { useGetApiLog } from '@/hooks/useDocuments'
import { LogDetail } from 'BrokerTsLib/src/components'
import { useParams } from 'react-router-dom'


export const LogDetailPage = () => {
    const { apiLogId: apiLogIdStr } = useParams()
    const { data, isLoading } = useGetApiLog(Number(apiLogIdStr))

    return (
        <>
            {isLoading && <AppLoading />}
            {data && <LogDetail apiLogDetail={data} />}
        </>
    )
}